import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import RouteTitle from '../../../../presentation/RouteTitle';
import Alerts from '../../../../prototypes/Alerts';
import InvoiceForm from './InvoiceForm';

class VendorInvoice extends React.Component {

  constructor( props ){
    super( props );
    this.state = {};
  }

  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const title = 'Vendor Invoice';
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if( status === 410 ) {
      alerts.INFO( title, 'Your session has expired.' , 5000 );
      this.doLogOff();
    } else if( status === 500 ) {
      alerts.INFO( title, e.statusText , 5000 );
      this.doLogOff();
    // This only needs to warn the user
    } else if( status === 400 ) {
      alerts.WARNING( title, 'Request timed out.', 5000 );
    } else {
      alerts.CRITICAL( title, e );
    }
  }

  onRenderHeader(){
    return(
      <div className={'page-header'}> Vendor Invoice </div>
    );
  }

  render(){
    return ( <div className="page-container">
      <div className='page-worksheet'>
        <RouteTitle title='Vendor Invoice' />
        {this.onRenderHeader()}
        <InvoiceForm />
      </div>
    </div> );
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( VendorInvoice ) );


// WEBPACK FOOTER //
// ./src/content/enterprise/invoice/components/VendorInvoice.js